import { createApi } from '@reduxjs/toolkit/query/react';
import { apiResource, b2chatBaseQuery, B2ChatClientCatalog } from '@src/client';
import { RecordingStatus } from '@src/types/calls';

export const RECORDING_STATUS_POLLING_INTERVAL = 15_000;

export type GetRecordingStatusRequest = {
  callId: string;
};

export type GetRecordingStatusResponse = {
  data: {
    status: RecordingStatus;
  };
};

export type GetRecordingInfoRequest = {
  callId: string;
};

export type GetRecordingInfoResponse = {
  data: {
    status: RecordingStatus;
    url: string;
    duration: number; // seconds
  };
};

const recordingApi = createApi({
  reducerPath: 'recordingApi',
  baseQuery: b2chatBaseQuery,
  tagTypes: ['recording'],
  endpoints: ({ query }) => ({
    getRecordingStatus: query<
      GetRecordingStatusResponse,
      GetRecordingStatusRequest
    >({
      providesTags: (_result, _error, { callId }) => [
        { type: 'recording', id: callId },
      ],
      extraOptions: { maxRetries: 0 },
      query: ({ callId }) =>
        apiResource(
          B2ChatClientCatalog.resources.calls.actions.getRecordingStatus,
          {
            params: { callId },
            withJWT: true,
          }
        ),
    }),

    getRecordingInfo: query<GetRecordingInfoResponse, GetRecordingInfoRequest>({
      providesTags: (_result, _error, { callId }) => [
        { type: 'recording', id: callId },
      ],
      extraOptions: { maxRetries: 0 },
      query: ({ callId }) =>
        apiResource(
          B2ChatClientCatalog.resources.calls.actions.getRecordingInfo,
          {
            params: { callId },
            withJWT: true,
          }
        ),
    }),
  }),
});

export const {
  useGetRecordingStatusQuery,
  useLazyGetRecordingStatusQuery,
  useGetRecordingInfoQuery,
  useLazyGetRecordingInfoQuery,
} = recordingApi;

export default recordingApi;
